import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardBody, NavItem, NavLink, Nav, Input } from "reactstrap";
import DatePicker from 'react-datepicker';
import { Filter } from 'react-feather';
import { baseURL } from '../../../Services/api/baseURL';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import { useDataContext } from '../../../context/hooks/useDataContext';
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';
import * as XLSX from 'xlsx';

const BarChartClass = () => {
    const { categoryData } = useDataContext();
    const [activeTab, setActiveTab] = useState('revenue');
    const [data, setData] = useState([]);
    const [storeData, setStoreData] = useState([]);
    const [categoryId, setCategoryId] = useState("");
    const [startDate, setStartDate] = useState(new Date());
    const [totalDataCount, setTotalDataCount] = useState();
    const [loading, setLoading] = useState(false);
    const [revenueList, setRevenueList] = useState([]);
    const [formattedStartDate, setFormattedStartDate] = useState(format(new Date(), 'MMM yyyy'));

    const handleDateChange = (date) => {
            if (!date) return;
        const formatted = format(date, 'MMM yyyy'); // e.g., "Jun 2025"
        console.log(formatted, "formatted date");
        setStartDate(date);
        setFormattedStartDate(formatted);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    // const fetchStores = async () => {
    //     const token = await JSON.parse(localStorage.getItem("token"));
    //     try {
    //         const stores = await axios.get(`${baseURL}/api/store/get-all-stores`, {
    //             headers: {
    //                 Authorization: `${token}`,
    //             },
    //         });
    //         let filteredData = stores?.data?.data.filter((item) => item.status === "active");
    //         setStoreData(filteredData || []);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    useEffect(() => {
        const fetchData = async () => {
            const token = await JSON.parse(localStorage.getItem("token"));
            let params = {};
            setLoading(true);
            // if (startDate) params.date = moment(startDate).format('MM-YYYY');
            if (categoryId) params.categoryId = categoryId;
            if (formattedStartDate) params.month = String(formattedStartDate)
            try {
                const response = await axios.get(`${baseURL}/api/dashboard/analytics`, {
                    params: params,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });

                if (response && response.data.success) {
                    console.log(response.data)
                    let responseData = response?.data?.stats;
                    console.log(responseData.transactions)
                    console.log(responseData.users)
                    console.log(responseData.orders)
                    switch (activeTab) {
                        case 'revenue':
                            setTotalDataCount(0);
                            setData(responseData?.transactions?.daily);
                            // setRevenueList(responseData?.transactions?.daily.sort((a, b) => new Date(a._id.year, a._id.month, a._id.day) - new Date(b._id.year, b._id.month, b._id.day)))
                            setTotalDataCount(responseData?.transactions?.total);
                            setLoading(false);
                            break;
                        case 'order':
                            setTotalDataCount(0);
                            setData(responseData?.orders.daily);
                            setTotalDataCount(responseData?.orders?.total);
                            setLoading(false);
                            break;
                        case 'customer':
                            setTotalDataCount(0);
                            setData(responseData.users?.daily);
                            setTotalDataCount(responseData?.users?.total);
                            setLoading(false);
                            break;
                        default:
                            setData([]);
                            setTotalDataCount(0);
                            setLoading(false);
                            break;
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, [activeTab, startDate, categoryId]);

    // useEffect(() => {
    //     fetchStores();
    // }, [])

    // const totalCount = data.reduce((acc, curr) => acc + curr.count, 0);

    function capitalizeFirstLetter(string) {
        return string?.charAt(0)?.toUpperCase() + string.slice(1);
    }
    const handleReportDownload = () => {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape
        const doc = new jsPDF(orientation, unit, size);

        // Headers for each report
        const headers = ['Date', 'No. of Orders', 'Total Revenue'];
        let pdfData = [];

        // Extract data from the response for each report type
        const reports = ['revenue', 'order', 'customer'];
        reports.forEach(reportType => {
            // Extract data based on the report type
            let reportData = [];
            switch (reportType) {
                case 'revenue':
                    reportData = data || [];
                    break;
                case 'order':
                    reportData = data || [];
                    break;
                case 'customer':
                    reportData = data || [];
                    break;
                default:
                    reportData = [];
                    break;
            }

            // Add a section title for each report
            pdfData.push([{ content: `${capitalizeFirstLetter(reportType)} Data`, colSpan: 3, styles: { halign: 'center' } }]);

            // Add report data
            reportData.forEach(entry => {
                pdfData.push([
                    moment(entry?._id).format('MMMM Do YYYY'), // Assuming _id represents the date
                    entry?.count || 0,
                    entry?.totalCount || 0
                ]);
            });

            // Add an empty row as a separator between reports
            pdfData.push(['', '', '']);
        });

        // Add data to PDF
        doc.autoTable({
            head: [headers],
            body: pdfData
        });

        // Save PDF
        doc.save(`all_reports_${moment().format('YYYY-MM-DD')}.pdf`);
    };

    const downloadExcel = () => {
        // Extracting revenue data
        const revenueData = [
            ['Date', 'No. of Orders', 'Total Revenue']
        ];

        revenueList.forEach(item => {
            const date = `${item._id.year}-${item._id.month}-${item._id.day}`;
            revenueData.push([date, item.count, item.totalCount]);
        });

        const workbook = XLSX.utils.book_new();

        console.log("data?.revenue?.data", data);

        // Add revenue sheet
        const revenueWorksheet = XLSX.utils.aoa_to_sheet(revenueData);
        XLSX.utils.book_append_sheet(workbook, revenueWorksheet, 'Revenue');

        // Convert workbook to buffer
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Convert buffer to Blob
        const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create download link and trigger download
        const excelFilename = `revenue_${moment().format('YYYY-MM-DD')}.xlsx`;
        const excelDownloadLink = document.createElement('a');
        excelDownloadLink.href = URL.createObjectURL(excelBlob);
        excelDownloadLink.download = excelFilename;
        excelDownloadLink.click();
    };



    return (
        <Fragment>
            <Col xl="12" md="12">
                <Card>

                    <div className="card-header d-flex align-items-center justify-between" style={{ padding: '15px 30px' }}>
                        <Nav tabs className='product_variant_tabs'>
                            <NavItem>
                                <NavLink className={activeTab === 'revenue' ? 'active' : ''} onClick={() => handleTabClick('revenue')}>
                                    Revenue
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={activeTab === 'order' ? 'active' : ''} onClick={() => handleTabClick('order')}>
                                    Order
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={activeTab === 'customer' ? 'active' : ''} onClick={() => handleTabClick('customer')}>
                                    Customer
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <div className='d-flex align-items-center file-content file-content-dash'>
                            {/* <Input type='select'>
                                <option value=''>All Stores</option>
                                {storeData && storeData.length > 0 && storeData.map((data) => (
                                    <option key={data._id} value={data._id}>{data.storeName}</option>
                                ))}
                            </Input> */}
                            {/* <Input type='select' name='product_id' className='ms-2' onChange={(e) => setCategoryId(e.target.value)}>
                                <option value=''>All Category</option>
                                {categoryData && categoryData.length > 0 && categoryData.map((data) => (
                                    <option key={data._id} value={data._id}>{data.collection_name}</option>
                                ))}
                            </Input> */}
                            <DatePicker className="datepickerr form-control digits mx-2"
                                selected={startDate}
                                onChange={(date) => {
                                    if (!date) {
                                        setStartDate(null);
                                        return;
                                    }
                                    handleDateChange(date);
                                }}
                                dateFormat="MMM yyyy"
                                showMonthYearPicker
                                yearItemNumber={9}

                                showIcon
                                // maxDate={new Date()} // 🔒 Disable future months

                                placeholderText='Select Month'

                            />
                            {/* {
                                activeTab === 'revenue' &&
                                <button type='button' className='btn btn-secondary' onClick={downloadExcel}>
                                    Download Excel
                                </button>
                            } */}
                            {/* <Button type='button' className='filter_btn'>
                                <Filter color='#1D2433CC' size={16} />
                            </Button> */}
                        </div>
                    </div>

                    <CardBody className="chart-block" style={{ padding: '15px' }}>
                        {data && (
                            <div style={{ position: 'relative', height: '500px' }}>
                                <Bar
                                    data={{
                                        labels: Array.from(
                                            { length: moment(startDate).daysInMonth() },
                                            (_, i) =>
                                                moment(startDate)
                                                    .startOf('month')
                                                    .add(i, 'days')
                                                    .format('DD')
                                        ),
                                        datasets: [
                                            {
                                                label: 'Count',
                                                data: Array.from(
                                                    { length: moment(startDate).daysInMonth() },
                                                    (_, i) => {
                                                        const dateKey = moment(startDate)
                                                            .startOf('month')
                                                            .add(i, 'days')
                                                            .format('YYYY-MM-DD');
                                                        return data[dateKey] || 0; // use 0 if no data
                                                    }
                                                ),
                                                backgroundColor: '#D95D39',
                                                borderColor: '#D95D39', // ✅ border same as bar color
                                                borderWidth: 2,
                                                borderRadius: 5,
                                            },
                                        ],
                                    }}
                                    options={{
                                        plugins: {
                                            legend: { display: false },
                                            title: {
                                                display: true,
                                                position: 'bottom',
                                                text: startDate
                                                    ? moment(startDate).format('MMM YYYY')
                                                    : 'Custom Chart Title',
                                                padding: { top: 20 },
                                            },
                                            datalabels: {
                                                display: false, // ✅ hide numbers on top of bars
                                            },
                                        },
                                        scales: {
                                            x: {
                                                grid: { display: false }, // ✅ hide vertical grid lines
                                                border: { display: false }, // ✅ hide bottom axis line
                                                ticks: {
                                                    color: '#555', // optional: subtle label color
                                                    font: { size: 12 },
                                                },
                                            },
                                            y: {
                                                grid: { display: false }, // ✅ hide horizontal grid lines
                                                border: { display: false }, // ✅ hide left axis line
                                                ticks: {
                                                    beginAtZero: true,
                                                    display: false, // ✅ hide Y-axis ticks
                                                },
                                            },
                                        },
                                        maintainAspectRatio: false,
                                        responsive: true,
                                        layout: { padding: { top: 50, bottom: 20 } },
                                    }}
                                />

                                {/* Header Overlay */}
                                <div>
                                    <h5
                                        className="fw-bolder"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            margin: 0,
                                        }}
                                    >
                                        {capitalizeFirstLetter(activeTab)}
                                    </h5>

                                    <p
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            margin: 0,
                                        }}
                                    >
                                        {/* {activeTab !== 'customer' && ( */}
                                        <span>
                                            <b>Total {capitalizeFirstLetter(activeTab)}:</b>{' '}
                                            {activeTab === 'revenue' ? '₹' : ''}
                                            {activeTab === 'revenue' ? totalDataCount?.toFixed(2) : totalDataCount}
                                        </span>
                                        {/* // )} */}
                                    </p>
                                </div>
                            </div>
                        )}

                    </CardBody>








                    {/* <CardBody className="chart-block" style={{ padding: '15px' }}>
                        {data && (
                            <div style={{ position: 'relative' }}>
                                <Bar
                                    data={{
                                        labels: data.map(entry => `${entry._id.day}`),
                                        datasets: [{
                                            label: 'Count',
                                            data: data.map(entry => entry.count),
                                            backgroundColor: "rgb(211, 23, 138)",
                                            borderRadius: 5,
                                            borderWidth: 2,
                                            datalabels: {
                                                color: 'black',
                                                anchor: 'end',
                                                align: 'top'
                                            }
                                        }]
                                    }}
                                    options={{
                                        plugins: {
                                            legend: {
                                                display: false,
                                            },

                                            title: {
                                                display: true,
                                                position: 'bottom',
                                                text: startDate ? moment(startDate).format('MMM YYYY') : 'Custom Chart Title',
                                                padding: {
                                                    // bottom: 20,
                                                    top: 20
                                                },
                                            },

                                        },

                                        maintainAspectRatio: false,
                                        responsive: true,
                                        layout: {
                                            padding: {
                                                top: 50,
                                                bottom: 20,
                                            },
                                        },
                                    }}
                                />
                                <div >
                                    <h5 style={{ position: 'absolute', top: 0, left: 0, margin: '0' }} className='fw-bolder'>{capitalizeFirstLetter(activeTab)}</h5>
                                    <p style={{ position: 'absolute', top: 0, right: 0 }}>
                                        {activeTab !== 'customer' && (
                                            <span>
                                                <b>Total {capitalizeFirstLetter(activeTab)}:</b> ${totalDataCount ? totalDataCount : 0}
                                            </span>
                                        )}
                                    </p>
                                    {/* <p>Total Order Count: {totalOrderCount}</p> */}
                    {/* </div>
                            </div>
                        )}
                    </CardBody> */}

                </Card>
            </Col>
        </Fragment>
    )
}

export default BarChartClass;
